<template>
  <div class="main-menu">
    <div class="navbar-wrapper">
      <div class="navbar navbar-inverse navbar-fixed-top" role="navigation">
        <div class="container">
          <div class="navbar-header">
            <button
              type="button"
              class="navbar-toggle"
              data-toggle="collapse"
              data-target=".navbar-collapse"
            >
              <span class="sr-only">Toggle Navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <router-link class="navbar-brand" to="/" :exact="true"
              ><img
                src="/dist/assets/img/logos/Logo_main_hr_001.png"
                alt="OTANG CARE LTD Logo"
            /></router-link>
          </div>
          <div class="navbar-collapse collapse">
            <ul class="nav navbar-nav navbar-right">
              <li>
                <router-link to="/" :exact="true">Home</router-link>
              </li>
              <li class="dropdown">
                <a
                  href="#"
                  class="dropdown-toggle"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  > About us <span class="caret"></span
                ></a>
                <ul class="dropdown-menu">
                  <li>
                    <router-link to="/who-we-are">Who we are</router-link>
                  </li>
                  <li>
                    <router-link to="/our-staff">Our staff</router-link>
                  </li>
                  <li>
                    <router-link to="/our-values">Our values</router-link>
                  </li>
                </ul>
              </li>
              <li>
                <router-link to="/our-services">Our services</router-link>
              </li>
              <li>
                <router-link to="/job-dashboard">Jobs</router-link>
              </li>
              <!-- <li>
                <router-link to="/job-dashboard">International Recruitment</router-link>
              </li>  -->

              <li>
                <router-link to="/contact-us">Contact us</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    window.$(".main-menu").sticky({ topSpacing: 0 });
  },
};
</script>
